import { type } from "./QuizRunner";
import { useEffect } from "react";
import { AccountType } from "../../components/constants/constants";

export default function SaveQuizOnRefresh(
  isReview,
  data,
  creatQuizDataAndSave,
  AssessmentSave,
  showWarning
) {
  useEffect(() => {
    if (isReview === undefined && data.user_type === AccountType.STUDENT) {
      window.addEventListener("beforeunload", alertUser);
      return () => {
        window.removeEventListener("beforeunload", alertUser);
      };
    }
  });

  const alertUser = (e) => {
    if (isReview === undefined) {
      if (showWarning !== false) {
        if (data.type === type.Exercise) {
          creatQuizDataAndSave();
        } else if (data.type === type.Assessment) {
          AssessmentSave();
        }
      }
    }
  };
}
